import gql from 'graphql-tag';
import {
  QuestionRuleInstanceFragment,
  ReportRuleInstanceFragment,
} from '@jupiterone/jupiter-web-toolkit';

export const UpdateAlertInstance = gql`
  mutation UpdateAlertInstance($instance: UpdateAlertInstanceInput!) {
    updateAlertInstance(instance: $instance) {
      id
      accountId
      ruleId
      lastUpdatedOn
      createdOn
      dismissedOn
      level
      status
      questionRuleInstance {
        ...QuestionRuleInstanceFragment
      }
      reportRuleInstance {
        ...ReportRuleInstanceFragment
      }
    }
  }
  ${QuestionRuleInstanceFragment}
  ${ReportRuleInstanceFragment}
`;

export const updateQuestionRuleInstance = gql`
  mutation UpdateQuestionRuleInstance(
    $instance: UpdateQuestionRuleInstanceInput!
  ) {
    updateQuestionRuleInstance(instance: $instance) {
      ...QuestionRuleInstanceFragment
    }
  }
  ${QuestionRuleInstanceFragment}
`;

export const deleteQuestionRuleInstance = gql`
  mutation DeleteRuleInstance($id: ID!) {
    deleteRuleInstance(id: $id) {
      id
    }
  }
`;

export const createQuestionRuleInstance = gql`
  mutation CreateQuestionRuleInstance(
    $instance: CreateQuestionRuleInstanceInput!
  ) {
    createQuestionRuleInstance(instance: $instance) {
      ...QuestionRuleInstanceFragment
    }
  }
  ${QuestionRuleInstanceFragment}
`;

export const evaluateRule = gql`
  mutation EvaluateRuleInstance($id: ID!) {
    evaluateRuleInstance(id: $id) {
      id
    }
  }
`;
